<template>
  <div class="registerCardStyle">
    <UserBase :loginLink="false">
      <template #default>
        <!-- ネクストエンジン連携時の文言表示 -->
        <v-row
          v-show="userInfo.neUid !== null && userInfo.neState !== null"
          no-gutters
          class="pb-2"
          justify="center"
          align-content="center"
        >
          <div class="nextengine-message">
            {{ $t('nextengine.nextengine_cooperate-title') }}
          </div>
        </v-row>
        <v-row no-gutters class="pb-2" justify="center" align-content="center">
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.mail"
              :placeholder="$t('common.input_mailaddress')"
              :rules="validations.mail.rules"
              type="email"
              outlined
              dense
              :hide-details="!isShowErrorMessage('mail')"
              height="36"
              @blur="validations.mail.isInput = true"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="py-2" justify="center" align-content="center">
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.password"
              :placeholder="$t('common.input_password')"
              :rules="validations.password.rules"
              type="password"
              outlined
              dense
              :hide-details="!isShowErrorMessage('password')"
              height="36"
              @blur="validations.password.isInput = true"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="py-3" justify="center" align-content="center">
          <v-col cols="10">
            <div class="primary--text text-center">
              <NormalLink
                :text="$t('auth.login_password-link')"
                link="/user/password-reset-mail"
              />
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="10" class="py-5">
            <NormalButton
              :text="$t('auth.login_login')"
              height="50px"
              @click="execLogin"
            />
          </v-col>
        </v-row>
        <v-row no-gutters class="py-3" justify="center" align-content="center">
          <v-col cols="10">
            <div class="primary--text text-center">
              <NormalLink
                :text="$t('auth.login_account-generate')"
                link="/user/register"
              />
            </div>
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import { UserBase } from '@/components/layouts'
import { NormalButton, NormalLink } from '@/components/items'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { commonUtil } from '@/util'
import mutationsTypes from '@/store/mutationTypes'
import { TO_STATUS } from '@/config/master/tutorial'

const regexp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/ // eslint-disable-line

export default {
  components: {
    UserBase,
    NormalLink,
    NormalButton
  },
  data: () => {
    return {
      validations: {
        mail: { isInput: false, rules: [] },
        password: { isInput: false, rules: [] }
      },
      userInfo: {
        mail: '',
        password: '',
        neUid: null,
        neState: null
      },
      isFetching: false
    }
  },
  created() {
    this.makeValidationRules()

    // URLのクエリパラメータを取得
    const uid = this.$route.query.uid
    const state = this.$route.query.state

    // 必要に応じてデータに保存
    if (uid) {
      this.userInfo.neUid = uid
    }
    if (state) {
      this.userInfo.neState = state
    }
  },
  computed: {
    isVaridationsError() {
      return (
        this.isShowErrorMessage('mail') || this.isShowErrorMessage('password')
      )
    },
    isDisabledExecButton() {
      if (this.isFetching) {
        return true
      }
      if (this.isVaridationsError) {
        return true
      }
      if (!this.userInfo.mail || !this.userInfo.password) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('Auth', ['login', 'requestMailVerify']),
    ...mapGetters('Auth', ['mailVerifyUrl']),
    ...mapActions('User', ['getUserInfoFromApi']),
    ...mapGetters('User', ['getUserInfoFromState']),
    ...mapActions('User', ['getUserInfoFromApi']),
    ...mapGetters('User', ['getUserInfoFromState']),
    ...mapMutations('Auth', [mutationsTypes.AUTH_SET_MAIL_VERIFY_URL]),
    async execLogin() {
      let isSuccess = await this.login({
        email: this.userInfo.mail,
        password: this.userInfo.password
      })
      if (isSuccess) {
        if (!this.mailVerifyUrl()) {
          // 通常ログイン
          // commonUtil.bulkGetMasterData()
          const user = await this.getUserInfoFromApi()
          if (user && !user.data.emailVerifiedAt) {
            alert(this.$t('common.common_mail-auth-uncompleted'))
          } else {
            this.switchRouting()
          }
        } else {
          // 新規登録時のフローの場合はメール認証APIを実行する必要がある
          const verified = await this.requestMailVerify()
          this[mutationsTypes.AUTH_SET_MAIL_VERIFY_URL]({
            mailVerifyUrl: ''
          })
          if (!verified) return

          // await commonUtil.bulkGetMasterData()
          // 会社情報等登録済みならTopへ
          const user = await this.getUserInfoFromApi()
          if (user.data.organization.name) {
            this.switchRouting()
          } else {
            this.$router.push({ name: 'user.profile' }).catch(() => {})
          }
        }
      }
    },
    async execRegisterUser() {
      this.isFetching = true
      const isSucceed = await this.registerUser({
        email: this.userInfo.mail,
        password: this.userInfo.password
      })
      this.isFetching = false
      if (isSucceed) {
        this.$router
          .push({
            name: 'user.login.success'
          })
          .catch(() => {})
      }
    },
    checkPasswordVarid(str) {
      const ratz = /[a-z]/,
        rAtZ = /[A-Z]/,
        r0t9 = /[0-9]/
      return (
        ratz.test(str) && rAtZ.test(str) && r0t9.test(str) && str.length > 7
      )
    },
    isShowErrorMessage(type) {
      const targetRule = this.validations[type]
      switch (type) {
        case 'mail':
          return (
            targetRule.isInput &&
            (!this.userInfo.mail || !regexp.test(this.userInfo.mail))
          )
        case 'password':
          return (
            targetRule.isInput &&
            (!this.userInfo.password ||
              !this.checkPasswordVarid(this.userInfo.password))
          )
        default:
          return
      }
    },
    makeValidationRules() {
      this.validations.mail.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) => regexp.test(v) || this.$t('common.common_is-email')
      ]
      this.validations.password.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) =>
          this.checkPasswordVarid(v) || this.$t('common.common_is-password')
      ]
    },
    switchRouting() {
      // ネクストエンジン初回連携からリダイレクトしてきたときの処理
      if (this.userInfo.neUid !== null && this.userInfo.neState !== null) {
        this.$router
          .push({
            name: 'nextengine-cooperate',
            query: {
              uid: this.userInfo.neUid,
              state: this.userInfo.neState
            }
          })
          .catch(() => {})
        return
      }

      // 通常のルーティング処理
      const tutorialStatus = this.getUserInfoFromState().tutorialStatus
      if (tutorialStatus === TO_STATUS.OPENED) {
        this.$router.push({ name: 'dashboard' }).catch(() => {})
        return
      }
      this.$router.push({ name: 'tutorial' }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
}
.nextengine-message {
  text-align: center; /* 文言を中央寄せ */
  margin-bottom: 20px; /* 文言の下部にマージンを追加 */
  font-size: 16px; /* 必要に応じてフォントサイズを調整 */
}
</style>
